export default __webpack_public_path__ + "static/media/cosmeticsbg.66a36f91.jpg";